import React from "react";
import { CheckCircle } from "lucide-react";

export interface PaymentSuccessProps {
  title: string;
  message: string;
  paymentMethod?: string;
}

const PaymentSuccess: React.FC<PaymentSuccessProps> = ({
  title,
  message,
  paymentMethod = "PIX"
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-8 flex flex-col items-center justify-center gap-6 w-full min-h-[450px] max-h-[450px]">
      <CheckCircle className="text-green-500 w-16 h-16" />
      <h1 className="text-xl font-bold text-center">{title}</h1>
      <p className="text-gray-600 text-center leading-relaxed">{message}</p>
      
      <div className="flex justify-between items-center w-full max-w-sm">
        <span className="text-gray-700 font-bold">Forma de pagamento</span>
        <span>{paymentMethod}</span>
      </div>
    </div>
  );
};

export default PaymentSuccess;
